// extracted by mini-css-extract-plugin
export default {"title-wrapper":"DrawerPlanDetails_title-wrapper__0Va4u","plan-info-list":"DrawerPlanDetails_plan-info-list__TsGmp","button":"DrawerPlanDetails_button__Rs6fE"};